import React from 'react';
import { Rocket, Shield, FileCheck, TrendingDown, Radio, Users, Target } from 'lucide-react';

const LogisticsKPIs = () => {
  const kpis = [
    { icon: Rocket, text: 'Faster driver and staff readiness' },
    { icon: Shield, text: 'Higher safety awareness' },
    { icon: FileCheck, text: 'Reduced compliance deviations' },
    { icon: TrendingDown, text: 'Fewer escalations and incidents' },
    { icon: Radio, text: 'Stronger dispatcher–driver coordination' },
    { icon: Users, text: 'Improved retention' },
    { icon: Target, text: 'More predictable operations' }
  ];

  return (
    <section className="py-24 px-6">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-12">
          <h2 className="text-4xl md:text-5xl font-bold mb-4 text-white">
            The KPIs Logistics Leaders Care About —
          </h2>
          <p className="text-2xl text-cyan-400 font-semibold">
            Improved
          </p>
          <p className="text-lg text-gray-400 mt-4">
            Organizations using Traain see:
          </p>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-6 max-w-6xl mx-auto">
          {kpis.map((kpi, index) => {
            const Icon = kpi.icon;
            return (
              <div
                key={index}
                className={`p-6 rounded-xl bg-gradient-to-br from-gray-900/80 to-blue-900/20 border border-cyan-500/30 hover:border-cyan-400/60 hover:shadow-lg hover:shadow-cyan-500/20 transition-all duration-300 text-center ${
                  index === 6 ? 'md:col-span-2 lg:col-span-4 lg:max-w-xs lg:mx-auto' : ''
                }`}
              >
                <Icon className="w-10 h-10 text-cyan-400 mx-auto mb-4" />
                <p className="text-gray-300">{kpi.text}</p>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default LogisticsKPIs;
